import App, {Tool} from "../App";
import Api from "./Api";
import Resource from "../Resource";

class OrgComplication {
    static list(props) {
        App.log('ORG_COMPLICATION.LIST', App.LOG.FETCH, props);

        const body = {
            // patientFileCode: null,
            // patientName: null,
            // productNumber: null,
            // startIndex: 0,
            // pageSize: 1000
        };

        return new Promise((resolve, reject) => {
            fetch(Api.COMPLICATION.ORG.LIST, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }
}

class SectionComplication {
    static delete(props) {
        App.log('SECTION_COMPLICATION.DELETE', App.LOG.FETCH, props);

        const body = {
            complicationId: props.complicationId,
            statusId: 72
        };

        return new Promise((resolve, reject) => {
            fetch(Api.COMPLICATION.SECTION.STATE_UPDATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.DELETE_FAILED);
            });
        });
    }

    static insert(props) {
        App.log('SECTION_COMPLICATION.INSERT', App.LOG.FETCH, props);

        const body = {
            outcomingDetailId: props.outcomingDetailId,
            clinicalStateJson2: {
                elatBastari: props?.clinicalStateJson2?.elatBastari,
                mizanHB: props?.clinicalStateJson2?.mizanHB,
                elatNiaz: props?.clinicalStateJson2?.elatNiaz,
                sabegheHameleghi: props?.clinicalStateJson2?.sabegheHameleghi,
                zamaneAkharinHameleghi: props?.clinicalStateJson2?.zamaneAkharinHameleghi,
                fesharKhon: props?.clinicalStateJson2?.fesharKhon,
                bimarieGhlabi: props?.clinicalStateJson2?.bimarieGhlabi,
                bimarieRiavi: props?.clinicalStateJson2?.bimarieRiavi,
                naghseImeni: props?.clinicalStateJson2?.naghseImeni,
                bimarieKoliavi: props?.clinicalStateJson2?.bimarieKoliavi,
                alerzhi: props?.clinicalStateJson2?.alerzhi,
                bimarieKabedi: props?.clinicalStateJson2?.bimarieKabedi,
                sabegheTazrigh: props?.clinicalStateJson2?.sabegheTazrigh,
                sabegheVakonesh: props?.clinicalStateJson2?.sabegheVakonesh,
                antiBiotics: props?.clinicalStateJson2?.antiBiotics
            },
            productInfoJson3: {
                tazrighDate: props?.productInfoJson3?.tazrighDate,
                tazrighStartTime: props?.productInfoJson3?.tazrighStartTime,
                arezeHeinTazrighVM: props?.productInfoJson3?.arezeHeinTazrighVM,
                kisehBetorKamelTazrighShode: props?.productInfoJson3?.kisehBetorKamelTazrighShode,
                patientState: props?.productInfoJson3?.patientState,
                rbcHot: props?.productInfoJson3?.rbcHot,
                rbcHotMethod: props?.productInfoJson3?.rbcHotMethod,
                productType: props?.productInfoJson3?.productType,
                productInfo24: props?.productInfoJson3?.productInfo24,
                count: props?.productInfoJson3?.count
            },
            clinicalSymptomsJson4: {
                darajeHararat_Before: props?.clinicalSymptomsJson4?.darajeHararat_Before,
                darajeHararat_After: props?.clinicalSymptomsJson4?.darajeHararat_After,
                tedadeNabz_Before: props?.clinicalSymptomsJson4?.tedadeNabz_Before,
                tedadeNabz_After: props?.clinicalSymptomsJson4?.tedadeNabz_After,
                fesharKhon_Before: props?.clinicalSymptomsJson4?.fesharKhon_Before,
                fesharKhon_After: props?.clinicalSymptomsJson4?.fesharKhon_After,
                tedadTanafos_Before: props?.clinicalSymptomsJson4?.tedadTanafos_Before,
                tedadTanafos_After: props?.clinicalSymptomsJson4?.tedadTanafos_After,
                dardehGhafasehSineh: props?.clinicalSymptomsJson4?.dardehGhafasehSineh,
                bigharari: props?.clinicalSymptomsJson4?.bigharari,
                ghermeziPost: props?.clinicalSymptomsJson4?.ghermeziPost,
                khonrizi: props?.clinicalSymptomsJson4?.khonrizi,
                tab: props?.clinicalSymptomsJson4?.tab,
                dardehShekam: props?.clinicalSymptomsJson4?.dardehShekam,
                ehsasehKakhoshi: props?.clinicalSymptomsJson4?.ehsasehKakhoshi,
                estridore: props?.clinicalSymptomsJson4?.estridore,
                raleRieh: props?.clinicalSymptomsJson4?.raleRieh,
                kaheshKhon: props?.clinicalSymptomsJson4?.kaheshKhon,
                afzaieshKhon: props?.clinicalSymptomsJson4?.afzaieshKhon,
                larz: props?.clinicalSymptomsJson4?.larz,
                ghateEdrar: props?.clinicalSymptomsJson4?.ghateEdrar,
                ghorGherefteghi: props?.clinicalSymptomsJson4?.ghorGherefteghi,
                viz: props?.clinicalSymptomsJson4?.viz,
                tahavoo: props?.clinicalSymptomsJson4?.tahavoo,
                dardehPosht: props?.clinicalSymptomsJson4?.dardehPosht,
                kamShodanHajmeEdrar: props?.clinicalSymptomsJson4?.kamShodanHajmeEdrar,
                kharesh: props?.clinicalSymptomsJson4?.kharesh,
                sardard: props?.clinicalSymptomsJson4?.sardard,
                taghireRanghEdrar: props?.clinicalSymptomsJson4?.taghireRanghEdrar,
                kahir: props?.clinicalSymptomsJson4?.kahir,
                takiPaneh: props?.clinicalSymptomsJson4?.takiPaneh,
                estefragh: props?.clinicalSymptomsJson4?.estefragh,
                beradiKardi: props?.clinicalSymptomsJson4?.beradiKardi,
                takikKardi: props?.clinicalSymptomsJson4?.takikKardi,
                saierehAlaiem: props?.clinicalSymptomsJson4?.saierehAlaiem,
                enfilterasionDoTarafeh: props?.clinicalSymptomsJson4?.enfilterasionDoTarafeh,
                bozorghiGhalb: props?.clinicalSymptomsJson4?.bozorghiGhalb,
                ehteghanOroghRiavi: props?.clinicalSymptomsJson4?.ehteghanOroghRiavi,
                saierehMavared: props?.clinicalSymptomsJson4?.saierehMavared,
                aborH_Before: props?.clinicalSymptomsJson4?.aborH_Before,
                aborH_After: props?.clinicalSymptomsJson4?.aborH_After,
                crossMatch_Before: props?.clinicalSymptomsJson4?.crossMatch_Before,
                crossMatch_After: props?.clinicalSymptomsJson4?.crossMatch_After,
                daT_Before: props?.clinicalSymptomsJson4?.daT_Before,
                daT_After: props?.clinicalSymptomsJson4?.daT_After,
                abScreening_Before: props?.clinicalSymptomsJson4?.abScreening_Before,
                abScreening_After: props?.clinicalSymptomsJson4?.abScreening_After,
                vojodeHBDarEdrar: props?.clinicalSymptomsJson4?.vojodeHBDarEdrar,
                vojodDBDarKhon: props?.clinicalSymptomsJson4?.vojodDBDarKhon,
                mizanehO2: props?.clinicalSymptomsJson4?.mizanehO2,
                natijehGheramAzBimar: props?.clinicalSymptomsJson4?.natijehGheramAzBimar,
                natijehGheramAzKhon: props?.clinicalSymptomsJson4?.natijehGheramAzKhon,
                mizanehPotasiom: props?.clinicalSymptomsJson4?.mizanehPotasiom
            },
            complicationDiagnosticJson5: {
                tashkhiseNoeeArezeh: props?.complicationDiagnosticJson5?.tashkhiseNoeeArezeh,
                acuteOrDelayed: props?.complicationDiagnosticJson5?.acuteOrDelayed,
                immuneOrNoneImmune: props?.complicationDiagnosticJson5?.immuneOrNoneImmune,
                aboOrAllo: props?.complicationDiagnosticJson5?.aboOrAllo,
                borozehKhataDarBakhsh: props?.complicationDiagnosticJson5?.borozehKhataDarBakhsh,
                borozehKhataDarBimarestan: props?.complicationDiagnosticJson5?.borozehKhataDarBimarestan,
                ttl: props?.complicationDiagnosticJson5?.ttl,
                viral: props?.complicationDiagnosticJson5?.viral,
                bacterial: props?.complicationDiagnosticJson5?.bacterial,
                anghali: props?.complicationDiagnosticJson5?.anghali,
                saierehOfonatha: props?.complicationDiagnosticJson5?.saierehOfonatha,
                hiv: props?.complicationDiagnosticJson5?.hiv,
                hbv: props?.complicationDiagnosticJson5?.hbv,
                hcv: props?.complicationDiagnosticJson5?.hcv,
                otherViralInfection: props?.complicationDiagnosticJson5?.otherViralInfection,
                saierehTashkhishha: props?.complicationDiagnosticJson5?.saierehTashkhishha,
                tozihat: props?.complicationDiagnosticJson5?.tozihat,
                shedatehArezeh: props?.complicationDiagnosticJson5?.shedatehArezeh,
                tozihatDarsoratehMargh: props?.complicationDiagnosticJson5?.tozihatDarsoratehMargh
            },
            healthActionJson6: {
                tajvizehTabBor: props?.healthActionJson6?.tajvizehTabBor,
                tajvizehMosaken: props?.healthActionJson6?.tajvizehMosaken,
                tajvizehAntiHistamin: props?.healthActionJson6?.tajvizehAntiHistamin,
                tajvizehEstroed: props?.healthActionJson6?.tajvizehEstroed,
                tajvizehDiortike: props?.healthActionJson6?.tajvizehDiortike,
                tajvizehVazoprosorha: props?.healthActionJson6?.tajvizehVazoprosorha,
                tajvizehAntiBiotice: props?.healthActionJson6?.tajvizehAntiBiotice,
                tajvizehOksizhen: props?.healthActionJson6?.tajvizehOksizhen,
                tahveiehMekaniki: props?.healthActionJson6?.tahveiehMekaniki,
                icu: props?.healthActionJson6?.icu,
                jojeiat: props?.healthActionJson6?.jojeiat,
                ayaBimarAzMahaleTazrighKhon: props?.healthActionJson6?.ayaBimarAzMahaleTazrighKhon
            },
            documentAbilityJson7: {
                certain: props?.documentAbilityJson7?.certain,
                probable: props?.documentAbilityJson7?.probable,
                possible: props?.documentAbilityJson7?.possible,
                exclude: props?.documentAbilityJson7?.exclude,
                notApplicable: props?.documentAbilityJson7?.notApplicable
            },
            clinicalRelatedStateJson8: {
                status: props?.clinicalRelatedStateJson8?.status,
                hospitalName: props?.clinicalRelatedStateJson8?.hospitalName
            },
            relatedPersonJson9: {
                nurseName: props?.relatedPersonJson9?.nurseName,
                creatorName: props?.relatedPersonJson9?.creatorName,
                docterName: props?.relatedPersonJson9?.docterName,
                hemovigilanceDocterName: props?.relatedPersonJson9?.hemovigilanceDocterName
            }
        };

        return new Promise((resolve, reject) => {
            fetch(Api.COMPLICATION.SECTION.INSERT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList[0]);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(message => {
                reject(message);
            });
        });
    }

    static list(props) {
        App.log('SECTION_COMPLICATION.LIST', App.LOG.FETCH, props);

        const body = {
            patientFileCode: null,
            patientName: null,
            productNumber: null,
            startIndex: 0,
            pageSize: 1000
        };

        return new Promise((resolve, reject) => {
            fetch(Api.COMPLICATION.SECTION.LIST, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static update(props) {
        App.log('SECTION_COMPLICATION.UPDATE', App.LOG.FETCH, props);

        const body = {
            complicationId: props.complicationId,
            clinicalStateJson2: {
                elatBastari: props?.clinicalStateJson2?.elatBastari,
                mizanHB: props?.clinicalStateJson2?.mizanHB,
                elatNiaz: props?.clinicalStateJson2?.elatNiaz,
                sabegheHameleghi: props?.clinicalStateJson2?.sabegheHameleghi,
                zamaneAkharinHameleghi: props?.clinicalStateJson2?.zamaneAkharinHameleghi,
                fesharKhon: props?.clinicalStateJson2?.fesharKhon,
                bimarieGhlabi: props?.clinicalStateJson2?.bimarieGhlabi,
                bimarieRiavi: props?.clinicalStateJson2?.bimarieRiavi,
                naghseImeni: props?.clinicalStateJson2?.naghseImeni,
                bimarieKoliavi: props?.clinicalStateJson2?.bimarieKoliavi,
                alerzhi: props?.clinicalStateJson2?.alerzhi,
                bimarieKabedi: props?.clinicalStateJson2?.bimarieKabedi,
                sabegheTazrigh: props?.clinicalStateJson2?.sabegheTazrigh,
                sabegheVakonesh: props?.clinicalStateJson2?.sabegheVakonesh,
                antiBiotics: props?.clinicalStateJson2?.antiBiotics
            },
            productInfoJson3: {
                tazrighDate: props?.productInfoJson3?.tazrighDate,
                tazrighStartTime: props?.productInfoJson3?.tazrighStartTime,
                arezeHeinTazrighVM: props?.productInfoJson3?.arezeHeinTazrighVM,
                kisehBetorKamelTazrighShode: props?.productInfoJson3?.kisehBetorKamelTazrighShode,
                patientState: props?.productInfoJson3?.patientState,
                rbcHot: props?.productInfoJson3?.rbcHot,
                rbcHotMethod: props?.productInfoJson3?.rbcHotMethod,
                productType: props?.productInfoJson3?.productType,
                productInfo24: props?.productInfoJson3?.productInfo24,
                count: props?.productInfoJson3?.count
            },
            clinicalSymptomsJson4: {
                darajeHararat_Before: props?.clinicalSymptomsJson4?.darajeHararat_Before,
                darajeHararat_After: props?.clinicalSymptomsJson4?.darajeHararat_After,
                tedadeNabz_Before: props?.clinicalSymptomsJson4?.tedadeNabz_Before,
                tedadeNabz_After: props?.clinicalSymptomsJson4?.tedadeNabz_After,
                fesharKhon_Before: props?.clinicalSymptomsJson4?.fesharKhon_Before,
                fesharKhon_After: props?.clinicalSymptomsJson4?.fesharKhon_After,
                tedadTanafos_Before: props?.clinicalSymptomsJson4?.tedadTanafos_Before,
                tedadTanafos_After: props?.clinicalSymptomsJson4?.tedadTanafos_After,
                dardehGhafasehSineh: props?.clinicalSymptomsJson4?.dardehGhafasehSineh,
                bigharari: props?.clinicalSymptomsJson4?.bigharari,
                ghermeziPost: props?.clinicalSymptomsJson4?.ghermeziPost,
                khonrizi: props?.clinicalSymptomsJson4?.khonrizi,
                tab: props?.clinicalSymptomsJson4?.tab,
                dardehShekam: props?.clinicalSymptomsJson4?.dardehShekam,
                ehsasehKakhoshi: props?.clinicalSymptomsJson4?.ehsasehKakhoshi,
                estridore: props?.clinicalSymptomsJson4?.estridore,
                raleRieh: props?.clinicalSymptomsJson4?.raleRieh,
                kaheshKhon: props?.clinicalSymptomsJson4?.kaheshKhon,
                afzaieshKhon: props?.clinicalSymptomsJson4?.afzaieshKhon,
                larz: props?.clinicalSymptomsJson4?.larz,
                ghateEdrar: props?.clinicalSymptomsJson4?.ghateEdrar,
                ghorGherefteghi: props?.clinicalSymptomsJson4?.ghorGherefteghi,
                viz: props?.clinicalSymptomsJson4?.viz,
                tahavoo: props?.clinicalSymptomsJson4?.tahavoo,
                dardehPosht: props?.clinicalSymptomsJson4?.dardehPosht,
                kamShodanHajmeEdrar: props?.clinicalSymptomsJson4?.kamShodanHajmeEdrar,
                kharesh: props?.clinicalSymptomsJson4?.kharesh,
                sardard: props?.clinicalSymptomsJson4?.sardard,
                taghireRanghEdrar: props?.clinicalSymptomsJson4?.taghireRanghEdrar,
                kahir: props?.clinicalSymptomsJson4?.kahir,
                takiPaneh: props?.clinicalSymptomsJson4?.takiPaneh,
                estefragh: props?.clinicalSymptomsJson4?.estefragh,
                beradiKardi: props?.clinicalSymptomsJson4?.beradiKardi,
                takikKardi: props?.clinicalSymptomsJson4?.takikKardi,
                saierehAlaiem: props?.clinicalSymptomsJson4?.saierehAlaiem,
                enfilterasionDoTarafeh: props?.clinicalSymptomsJson4?.enfilterasionDoTarafeh,
                bozorghiGhalb: props?.clinicalSymptomsJson4?.bozorghiGhalb,
                ehteghanOroghRiavi: props?.clinicalSymptomsJson4?.ehteghanOroghRiavi,
                saierehMavared: props?.clinicalSymptomsJson4?.saierehMavared,
                aborH_Before: props?.clinicalSymptomsJson4?.aborH_Before,
                aborH_After: props?.clinicalSymptomsJson4?.aborH_After,
                crossMatch_Before: props?.clinicalSymptomsJson4?.crossMatch_Before,
                crossMatch_After: props?.clinicalSymptomsJson4?.crossMatch_After,
                daT_Before: props?.clinicalSymptomsJson4?.daT_Before,
                daT_After: props?.clinicalSymptomsJson4?.daT_After,
                abScreening_Before: props?.clinicalSymptomsJson4?.abScreening_Before,
                abScreening_After: props?.clinicalSymptomsJson4?.abScreening_After,
                vojodeHBDarEdrar: props?.clinicalSymptomsJson4?.vojodeHBDarEdrar,
                vojodDBDarKhon: props?.clinicalSymptomsJson4?.vojodDBDarKhon,
                mizanehO2: props?.clinicalSymptomsJson4?.mizanehO2,
                natijehGheramAzBimar: props?.clinicalSymptomsJson4?.natijehGheramAzBimar,
                natijehGheramAzKhon: props?.clinicalSymptomsJson4?.natijehGheramAzKhon,
                mizanehPotasiom: props?.clinicalSymptomsJson4?.mizanehPotasiom
            },
            complicationDiagnosticJson5: {
                tashkhiseNoeeArezeh: props?.complicationDiagnosticJson5?.tashkhiseNoeeArezeh,
                acuteOrDelayed: props?.complicationDiagnosticJson5?.acuteOrDelayed,
                immuneOrNoneImmune: props?.complicationDiagnosticJson5?.immuneOrNoneImmune,
                aboOrAllo: props?.complicationDiagnosticJson5?.aboOrAllo,
                borozehKhataDarBakhsh: props?.complicationDiagnosticJson5?.borozehKhataDarBakhsh,
                borozehKhataDarBimarestan: props?.complicationDiagnosticJson5?.borozehKhataDarBimarestan,
                ttl: props?.complicationDiagnosticJson5?.ttl,
                viral: props?.complicationDiagnosticJson5?.viral,
                bacterial: props?.complicationDiagnosticJson5?.bacterial,
                anghali: props?.complicationDiagnosticJson5?.anghali,
                saierehOfonatha: props?.complicationDiagnosticJson5?.saierehOfonatha,
                hiv: props?.complicationDiagnosticJson5?.hiv,
                hbv: props?.complicationDiagnosticJson5?.hbv,
                hcv: props?.complicationDiagnosticJson5?.hcv,
                otherViralInfection: props?.complicationDiagnosticJson5?.otherViralInfection,
                saierehTashkhishha: props?.complicationDiagnosticJson5?.saierehTashkhishha,
                tozihat: props?.complicationDiagnosticJson5?.tozihat,
                shedatehArezeh: props?.complicationDiagnosticJson5?.shedatehArezeh,
                tozihatDarsoratehMargh: props?.complicationDiagnosticJson5?.tozihatDarsoratehMargh
            },
            healthActionJson6: {
                tajvizehTabBor: props?.healthActionJson6?.tajvizehTabBor,
                tajvizehMosaken: props?.healthActionJson6?.tajvizehMosaken,
                tajvizehAntiHistamin: props?.healthActionJson6?.tajvizehAntiHistamin,
                tajvizehEstroed: props?.healthActionJson6?.tajvizehEstroed,
                tajvizehDiortike: props?.healthActionJson6?.tajvizehDiortike,
                tajvizehVazoprosorha: props?.healthActionJson6?.tajvizehVazoprosorha,
                tajvizehAntiBiotice: props?.healthActionJson6?.tajvizehAntiBiotice,
                tajvizehOksizhen: props?.healthActionJson6?.tajvizehOksizhen,
                tahveiehMekaniki: props?.healthActionJson6?.tahveiehMekaniki,
                icu: props?.healthActionJson6?.icu,
                jojeiat: props?.healthActionJson6?.jojeiat,
                ayaBimarAzMahaleTazrighKhon: props?.healthActionJson6?.ayaBimarAzMahaleTazrighKhon
            },
            documentAbilityJson7: {
                certain: props?.documentAbilityJson7?.certain,
                probable: props?.documentAbilityJson7?.probable,
                possible: props?.documentAbilityJson7?.possible,
                exclude: props?.documentAbilityJson7?.exclude,
                notApplicable: props?.documentAbilityJson7?.notApplicable
            },
            clinicalRelatedStateJson8: {
                status: props?.clinicalRelatedStateJson8?.status,
                hospitalName: props?.clinicalRelatedStateJson8?.hospitalName
            },
            relatedPersonJson9: {
                nurseName: props?.relatedPersonJson9?.nurseName,
                creatorName: props?.relatedPersonJson9?.creatorName,
                docterName: props?.relatedPersonJson9?.docterName,
                hemovigilanceDocterName: props?.relatedPersonJson9?.hemovigilanceDocterName
            }
        };

        return new Promise((resolve, reject) => {
            fetch(Api.COMPLICATION.SECTION.UPDATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(message => {
                reject(message);
            });
        });
    }
}

export {SectionComplication, OrgComplication};